export default function HelpAlertsItemsService(gettext) {
	'ngInject';

	this.getModule = function () {
		var module = {
			id: 'alerts',
			name: gettext('Alerts'),
			description: gettext(
				"This is where alert configurations are created and managed. Alerts can be set to notify who you would like when they have triggered, and how they will affect the color of the asset's map pin."
			),
			icon: 'fas fa-question-circle',
			priority: 5,
			items: [
				{
					orderid: 5.01,
					itemid: 'alertsdashboard',
					helpitemid: 'alerts',
					name: gettext('Alert Dashboard'),
					templateUrl: 'alerts/alerts.dashboard.html'
				},
				{
					orderid: 5.02,
					itemid: 'alertshistory',
					helpitemid: 'alerts',
					name: gettext('View Historical Alerts'),
					templateUrl: 'alerts/alerts.history.html'
				},
				{
					orderid: 5.03,
					itemid: 'alertsconfigurations',
					helpitemid: 'alerts.configurations',
					name: gettext('Alert Configurations'),
					templateUrl: 'alerts/alerts.configuration.html'
				},
				{
					orderid: 5.04,
					itemid: 'alertsconfigurationsedit',
					helpitemid: 'alerts.configurations.edit',
					name: gettext('Alert Configuration Details'),
					templateUrl: 'alerts/alerts.configuration.details.html'
				},
				{
					orderid: 5.05,
					itemid: 'alertsconfigurationscreate',
					helpitemid: 'alerts.configurations.edit',
					name: gettext('Create Alert Configuration'),
					templateUrl: 'alerts/alerts.configuration.create.html'
				},
				{
					orderid: 5.06,
					itemid: 'alertsconfigurationsexamples',
					helpitemid: 'alerts.configurations.edit',
					name: gettext('Alert Configuration Examples'),
					templateUrl: 'alerts/alerts.configuration.examples.html'
				},
				{
					orderid: 5.07,
					itemid: 'alertsfaults',
					helpitemid: 'alerts.faults',
					name: gettext('Fault Configurations'),
					templateUrl: 'alerts/faults/faults.configuration.html'
				},
				{
					orderid: 5.08,
					itemid: 'alertsfaultsedit',
					helpitemid: 'alerts.faults.edit',
					name: gettext('Fault Configuration Details'),
					templateUrl: 'alerts/faults/faults.configuration.details.html'
				},
				{
					orderid: 5.09,
					itemid: 'alertsfaultscreate',
					helpitemid: 'alerts.faults.edit',
					name: gettext('Create Fault Configuration'),
					templateUrl: 'alerts/faults/faults.configuration.create.html'
				},
				{
					orderid: 5.1,
					itemid: 'alertsgeozonelist',
					helpitemid: 'geozones',
					name: gettext('View GeoZones'),
					templateUrl: 'geozones/geozone.html'
				},
				{
					orderid: 5.11,
					itemid: 'alertsgeozonedetails',
					helpitemid: 'geozones',
					name: gettext('GeoZone Details'),
					templateUrl: 'geozones/geozone.details.html'
				},
				{
					orderid: 5.12,
					itemid: 'alertsgeozonecreate',
					helpitemid: 'geozones.manage',
					name: gettext('Create New GeoZone'),
					templateUrl: 'geozones/geozone.create.html'
				}
			]
		}; //use the state as ID e.g., alerts.dashboard = ""alertsdashboard""

		return module;
	};
}
